/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  id?: string,
}>;

const QuestionCircleFilledIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id={props.id}
  >
    <path d="M11.5,1 C5.148,1 0,6.148 0,12.5 C0,18.852 5.148,24 11.5,24 C17.852,24 23,18.852 23,12.5 C23,6.148 17.852,1 11.5,1 Z M11.5,19 C10.947,19 10.5,18.553 10.5,18 C10.5,17.448 10.947,17 11.5,17 C12.051,17 12.5,17.448 12.5,18 C12.5,18.553 12.051,19 11.5,19 Z M12,12.965 L12,15.5 C12,15.776 11.775,16 11.5,16 C11.224,16 11,15.776 11,15.5 L11,12.5 C11,12.224 11.224,12 11.5,12 C12.878,12 14,10.879 14,9.5 C14,8.121 12.878,7 11.5,7 C10.121,7 9,8.121 9,9.5 C9,9.776 8.775,10 8.5,10 C8.224,10 8,9.776 8,9.5 C8,7.57 9.569,6 11.5,6 C13.43,6 15,7.57 15,9.5 C15,11.26 13.693,12.721 12,12.965 Z" />
  </svg>
);

export default QuestionCircleFilledIcon;
